import { AsyncThunkAction } from 'actions/actions.types'
import { fetchMessengerChatAction } from 'actions/messenger/fetchMessengerChatAction'
import { pushToChatAction } from 'actions/messenger/pushToChatAction'
import { pushToChatWithWinkAction } from 'actions/messenger/pushToChatWithWinkAction'
import { ChatEventReasons } from 'actions/messengerStopChat/constants'
import { showStopChatIfNeeded } from 'actions/messengerStopChat/showStopChatIfNeeded'

export const foreignProfileSendWinkAction =
  (
    profileId: number,
    /**
     * Получаем из GQL.
     * Значение можно не передавать, это не критично. Значение не всегда доступно.
     */
    isWinked: boolean = false
  ): AsyncThunkAction =>
  async (dispatch) => {
    await dispatch(fetchMessengerChatAction({ profileId }))

    const showStopChat = dispatch(
      showStopChatIfNeeded(ChatEventReasons.ChatOpen)
    )

    if (showStopChat) {
      /**
       * Чтобы не создавать лишнюю навигацию (невозможность работы кнопки назад).
       * Не навигируем в чат.
       */
      return
    }

    if (!isWinked) {
      dispatch(pushToChatWithWinkAction(profileId))
      return
    }

    dispatch(pushToChatAction(profileId))
  }
